import { render, staticRenderFns } from "./KroksView.vue?vue&type=template&id=2ac8bf42"
import script from "./KroksView.vue?vue&type=script&lang=js"
export * from "./KroksView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports